// Zentrale Konfiguration — vom Betreiber editierbar (Werte aus .env)
export const CONTACT = {
  phone: process.env.REACT_APP_CONTACT_PHONE || "+49 000 0000000",
  phoneHref: (process.env.REACT_APP_CONTACT_PHONE || "+49 000 0000000").replace(/\s/g, ""),
  whatsapp: process.env.REACT_APP_CONTACT_WHATSAPP || "49000000000",
};

// Google-Ads Conversion-Konfiguration (echte IDs/Labels später in .env eintragen)
export const ADS = {
  conversionId: process.env.REACT_APP_ADS_CONVERSION_ID || "AW-XXXXXXXXXX",
  conversions: {
    chat_lead: {
      label: process.env.REACT_APP_ADS_LABEL_CHAT_LEAD || "chatLeadLabel",
      value: 100,
      primary: true,
    },
    lead_formular: {
      label: process.env.REACT_APP_ADS_LABEL_FORMULAR || "formularLabel",
      value: 80,
      primary: true,
    },
    anruf: {
      label: process.env.REACT_APP_ADS_LABEL_ANRUF || "anrufLabel",
      value: 50,
      primary: false,
    },
    rueckruf: {
      label: process.env.REACT_APP_ADS_LABEL_RUECKRUF || "rueckrufLabel",
      value: 50,
      primary: false,
    },
    whatsapp: {
      label: process.env.REACT_APP_ADS_LABEL_WHATSAPP || "whatsappLabel",
      value: 40,
      primary: false,
    },
  },
};

export function adsConfigured() {
  return ADS.conversionId && !ADS.conversionId.includes("XXXX");
}
